import { Carousel as ResponsiveCarousel } from 'react-responsive-carousel';
import { memo, useCallback } from 'react';

import { CarouselWrapperStyled, ControlIconWrapper } from './styled/CarouselStyled';
import { Icon } from '../icon/Icon';

const ControlIcon = memo(({ prev, onClick, hasNext }) => (
    <ControlIconWrapper hasNext={hasNext} onClick={onClick} prev={prev}>
        <Icon
            name="IcNextRound"
            height="32px"
            width="32px"
            asComponent
            style={{ transform: `rotate(${prev ? 180 : 0}deg)` }}
        />
    </ControlIconWrapper>
));

export const Carousel = memo(
    ({
        children,
        centerDots,
        className,
        dotsLeftOffset,
        showArrows = true,
        showStatus = false,
        showThumbs = false,
        ...carouselProps
    }) => {
        const renderArrowNext = useCallback(
            (handleClick, hasNext) => <ControlIcon onClick={handleClick} hasNext={hasNext} />,
            [],
        );
        const renderArrowPrev = useCallback(
            (handleClick, hasNext) => <ControlIcon onClick={handleClick} hasNext={hasNext} prev />,
            [],
        );

        return (
            <CarouselWrapperStyled centerDots={centerDots} dotsLeftOffset={dotsLeftOffset} className={className}>
                <ResponsiveCarousel
                    renderArrowNext={showArrows ? renderArrowNext : void 0}
                    renderArrowPrev={showArrows ? renderArrowPrev : void 0}
                    showArrows={showArrows}
                    showStatus={showStatus}
                    showThumbs={showThumbs}
                    preventMovementUntilSwipeScrollTolerance
                    {...carouselProps}
                >
                    {children}
                </ResponsiveCarousel>
            </CarouselWrapperStyled>
        );
    },
);